import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export const LOGO_STACKED =
  "https://customer-assets-agu9un31.emergentagent.net/job_studio-flow-55/artifacts/afdv1ste_Design%20Seleksa.webp";
export const LOGO_WIDE =
  "https://customer-assets-agu9un31.emergentagent.net/job_studio-flow-55/artifacts/gnu4hkz5_Design%20Seleksa%202.webp";

export const Brand = ({ to = "/", className = "", logo = null, name = null }) => (
  <Link to={to} className={`flex items-center gap-3 py-2 -my-2 ${className}`} data-testid="brand-link">
    <img src={logo || LOGO_WIDE} alt={name || "Seleksa"} className="h-8 w-auto object-contain" />
    {name && <span className="text-sm text-[#A8A8A8] hidden sm:block">{name}</span>}
  </Link>
);

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useI18n();
  return (
    <div className={`flex items-center border border-[#2A2A2A] ${className}`} data-testid="lang-toggle">
      {["id", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-3.5 py-2.5 min-h-[40px] text-[10px] tracking-[0.16em] uppercase font-mono-accent transition-colors ${
            lang === l ? "bg-[#D4AF37] text-black" : "text-[#A8A8A8] hover:text-[#D4AF37]"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow ${className}`}>{children}</p>
);

export const Stat = ({ label, value, testId, accent = false }) => (
  <div data-testid={testId}>
    <p className="text-[10px] tracking-[0.18em] uppercase text-[#707070]">{label}</p>
    <p className={`mt-1 font-mono-accent text-sm ${accent ? "text-[#D4AF37]" : ""}`}>{value}</p>
  </div>
);

export const inputClass =
  "w-full bg-transparent border-b border-[#2A2A2A] rounded-none px-0 py-3 text-base sm:text-sm text-[#F3F3F1] placeholder:text-[#5A5A5A] focus:border-[#D4AF37] focus:outline-none transition-colors duration-300";
export const labelClass = "block eyebrow mb-1";
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black px-7 py-3.5 min-h-[44px] text-[11px] tracking-[0.18em] uppercase font-semibold hover:bg-[#E6C96B] transition-colors duration-300 disabled:opacity-50";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 border border-[#2A2A2A] px-6 py-3 min-h-[44px] text-[11px] tracking-[0.18em] uppercase hover:border-[#D4AF37] transition-colors duration-300 disabled:opacity-50";

/** Wraps a small icon in a 44px touch area without changing how it looks. */
export const iconBtnClass = "inline-flex items-center justify-center w-11 h-11 -m-2 shrink-0 transition-colors";
